module.exports = __webpack_public_path__ + "media/botgarden-kotlin.42bb5e0c.mp4";